(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.stwrap-reviews-page').forEach(page => {
      if (page.dataset.stwrapReviewsReady) return;
      page.dataset.stwrapReviewsReady = 'true';
      const widget = page.querySelector('.jdgm-all-reviews-widget');
      const more = page.querySelector('.stwrap-reviews-page__more');
      if (!widget || !more) return;
      let limit = 6;
      let pending = false;
      const update = () => {
        pending = false;
        const reviews = [...widget.querySelectorAll('.jdgm-all-reviews__body .jdgm-rev')];
        reviews.forEach(review => review.removeAttribute('data-stwrap-review-collapsed'));
        const visible = reviews.filter(review => getComputedStyle(review).display !== 'none' && review.getClientRects().length);
        visible.forEach((review, index) => {
          if (index >= limit) review.setAttribute('data-stwrap-review-collapsed', '');
        });
        more.hidden = visible.length <= limit;
      };
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      };
      more.querySelector('button').addEventListener('click', () => { limit += 6; update(); });
      widget.addEventListener('click', event => {
        if (event.target.closest('.jdgm-subtab__name')) { limit = 6; schedule(); }
      });
      widget.addEventListener('change', () => { limit = 6; schedule(); });
      new MutationObserver(schedule).observe(widget, { childList:true, subtree:true });
      window.addEventListener('load', schedule, { once:true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
